import { Attribute } from '@models/attribute.model';

export const mapAttributeToUpdateRequest = (attribute: Attribute) => {
  const {createdAt, ...updateRequest} = attribute;
  return updateRequest;
};
